/**
 * Module definition and dependencies
 */
angular.module("Crm.Transaction.Controller", ["programmesService.Service", "signatures.Service", "transactionsService.Service", "configsService.Service", "lotsService.Service", "ngMessages"])
/**
 * Controller
 */
.controller("TransactionCtrl", ["$state", "ConfigsTransactions", "$scope", "$rootScope", "Auth", "Programme", function ($state, ConfigsTransactions, $scope, $rootScope, Auth, Programme) {
  this.listStatuts = [];
  this.tabsData = [{
    heading: "Historique de la transaction",
    route: "transaction.transactionhistorique"
  }, {
    heading: "Historique du client",
    route: "transaction.clienthistorique"
  }, {
    heading: "Documents",
    route: "transaction.clientdocuments"
  }];

  this.$onInit = () => {
    this.classTransaction = $rootScope.env && $rootScope.env === "immodesk" ? "col-xs-12" : "col-xs-12 col-md-10 col-md-offset-1 transaction-container";
    this.hasRolesAdmin = Auth.hasRole("admin");

    if ($state.params && $state.params.paramsFiltresTransactions) {
      this.paramsFiltresTransactions = $state.params.paramsFiltresTransactions;
    }

    this.stateSource = $state.params.stateSource || "transactionsTab.optionsVentes";
    this.datePickerOptionsPose = {
      formatYear: "yy",
      startingDay: 1,
      timezone: "Europe/Paris"
    }; // Date de debut de transaction

    let date = new Date();

    if (this.transaction.date_debut && this.transaction.date_debut.date) {
      date = new Date(this.transaction.date_debut.date);
    }

    this.datePickerOptionsEnd = {
      minDate: date,
      formatYear: "yy",
      startingDay: 1,
      timezone: "Europe/Paris"
    };
    this.datePickerOptionsDateSignatureNotaire = {
      formatYear: "yy",
      startingDay: 1,
      timezone: "Europe/Paris"
    };
    this.datePickerOptionsSignatureNotairePrev = {
      formatYear: "yy",
      startingDay: 1,
      timezone: "Europe/Paris"
    };
    ConfigsTransactions.getStatuts().then(response => {
      const typeIdVendu = 3;
      angular.forEach(response.data, (value, key) => {
        // type_id = 3 pour Vendu
        if (this.transaction.type_id === typeIdVendu) {
          if (this.listStatuts.find(v => v.id === this.transaction.type_id) || value.id !== typeIdVendu) {
            return;
          }

          this.listStatuts.push(value);
          return;
        } else if (this.transaction.type_id > value.id && value.id != typeIdVendu) {
          return;
        }

        this.listStatuts.push(value);
      });
    }).catch(error => {
      console.log("Erreur factory ConfigsTransactions getStatuts : " + error);
    });
    Programme.get({
      programmeId: this.lot.programme_id
    }).$promise.then(programme => {
      this.programme = programme;
      this.is_promoteur = $rootScope.membreConnecter && $rootScope.membreConnecter.employeur_id && this.programme.promoteur_id && $rootScope.membreConnecter.employeur_id != this.programme.promoteur_id;
    }).catch(error => {
      console.error("error :", error);
    });
  };

  this.back = () => {
    $state.go(this.stateSource, {
      paramsFiltresTransactions: this.paramsFiltresTransactions
    });
  };

  this.enregistrerTransaction = () => {
    this.transaction.transactionId = this.transaction.id; //delete espace et device_unit

    if (this.transaction.prix_ht && isNaN(this.transaction.prix_ht)) {
      this.transaction.prix_ht.replace(" ", "");
    }

    if (this.transaction.prix_ttc && isNaN(this.transaction.prix_ttc)) {
      this.transaction.prix_ttc.replace(" ", "");
    }

    if (this.transaction.prix && isNaN(this.transaction.prix)) {
      this.transaction.prix.replace(" ", "");
    }

    if (this.transaction.devise_unite) {
      if (this.transaction.prix_ht && isNaN(this.transaction.prix_ht)) {
        this.transaction.prix_ht.replace(this.transaction.devise_unite, "");
      }

      if (this.transaction.prix_ttc && isNaN(this.transaction.prix_ttc)) {
        this.transaction.prix_ttc.replace(this.transaction.devise_unite, "");
      }

      if (this.transaction.prix && isNaN(this.transaction.prix)) {
        this.transaction.prix.replace(this.transaction.devise_unite, "");
      }
    }

    if (this.transaction.date_signature_notaire && this.transaction.date_signature_notaire.date) {
      this.transaction.date_signature_notaire.date = moment(this.transaction.date_signature_notaire.date).format("YYYY-MM-DD");
    }

    if (this.transaction.date_signature_notaire_prev && this.transaction.date_signature_notaire_prev.date) {
      this.transaction.date_signature_notaire_prev.date = moment(this.transaction.date_signature_notaire_prev.date).format("YYYY-MM-DD");
    }

    return this.transaction.$update().then(function successCallback(response) {
      $rootScope.$broadcast("transactionUpdate");
    }, function errorCallback(response) {
      console.log("Erreur factory Transaction update : " + response);
      return false;
    });
  };

  this.calcDatePoseDateEnd = function () {
    if (!(this.transaction.date_validite && this.transaction.date_debut)) return;
    var datePose = moment(this.transaction.date_debut.date);
    var dateEnd = moment(this.transaction.date_validite.date);
    var diff = dateEnd.diff(datePose, "days");

    if (diff < 0) {
      this.transaction.date_validite.date = datePose;
    }

    this.datePickerOptionsEnd.minDate = datePose;
    this.transaction.duree_validite = diff;
  };

  $scope.$watch(() => this.transaction.date_validite && this.transaction.date_validite.date, (val, old) => {
    this.calcDatePoseDateEnd();
  }, true);
  $scope.$watch(() => this.transaction.date_debut && this.transaction.date_debut.date, (val, old) => {
    this.calcDatePoseDateEnd();
  }, true);
}]).controller("HistoriqueTransactionCtrl", ["HistoriqueTransactionDocument", "HistoriqueTransaction", "$q", "$scope", function (HistoriqueTransactionDocument, HistoriqueTransaction, $q, $scope) {
  this.$onInit = () => {
    this.listeHistorique = [];
    this.getHistoriqueTransactionDocument();
  };

  this.getHistoriqueTransactionDocument = () => {
    const tabPromises = [];
    this.listeHistorique = [];
    this.loading = true;

    if (this.transaction && this.transaction.contrat_reservation_id) {
      const historiqueTransactionDocument = HistoriqueTransactionDocument.get({
        transactionId: this.transaction.id,
        documentId: this.transaction.contrat_reservation_id
      }).$promise.then(response => response).catch(error => {
        this.loading = false;
        console.log("error : ", error);
      });
      tabPromises.push(historiqueTransactionDocument);
    }

    const historiqueTransaction = HistoriqueTransaction.get({
      transactionId: this.transaction.id
    }).$promise.then(historiques => {
      // Format historique => historiqueTransactionDocument
      historiques.map(historique => {
        historique.createdAt = historique.date_created && historique.date_created.date && historique.date_created.timezone ? moment(historique.date_created.date).unix() : null;
        historique.defaultMessage = historique.note;
      });
      return historiques;
    }).catch(error => {
      this.loading = false;
      console.log("error : ", error);
    });
    tabPromises.push(historiqueTransaction);
    $q.all(tabPromises).then(response => {
      this.loading = false;

      if (Array.isArray(response)) {
        response.map(resp => {
          if (Array.isArray(resp)) {
            resp.map(r => {
              this.listeHistorique.push(r);
            });
          }
        });
      }

      this.listeHistorique = this.listeHistorique.sort((a, b) => b.createdAt - a.createdAt);
    });
  };

  $scope.$on("refreshTransactionProcedure", () => {
    this.getHistoriqueTransactionDocument();
  });
  $scope.$on("contratRegenerer", (event, newTransaction) => {
    if (!newTransaction || !newTransaction.contrat_reservation_id) {
      console.log("error newTransaction / newTransaction.contrat_reservation_id is empty");
      return;
    }

    this.transaction.contrat_reservation_id = newTransaction.contrat_reservation_id;
    this.getHistoriqueTransactionDocument();
  });
}]).controller("BtnAbandonnerValiderTransactionCtrl", ["$uibModal", "$state", "Auth", function ($uibModal, $state, Auth) {
  this.$onInit = () => {
    this.hasRolesAdmin = Auth.hasRole("admin");
  };
  /*
   * Modal
   */


  this.openModal = btnDisabled => {
    if (btnDisabled || this.transaction.signature_procedure_status === 10) {
      return;
    }

    if (this.typeAction === "valider" && this.transaction.rang !== "1") {
      return false;
    }

    var modalInstance = $uibModal.open({
      templateUrl: "src/transaction/modal-transaction.html",
      controller: "TransactionModalCtrl",
      controllerAs: "$ctrl",
      resolve: {
        transaction: () => {
          return this.transaction;
        },
        typeAction: () => {
          return this.typeAction;
        },
        filtresTransactions: () => {
          return this.filtresTransactions;
        }
      }
    });
    modalInstance.result.then(typeAction => {
      if (!this.transaction) {
        return;
      }

      if (!typeAction) {
        $state.go("mesTransactions");
      }

      if (typeAction === "abandonner") {
        this.transactions.splice(this.transactions.indexOf(this.transaction), 1);
      }
    }, function () {});
  };
}]).controller("TransactionModalCtrl", ["$uibModalInstance", "$rootScope", "transaction", "typeAction", function ($uibModalInstance, $rootScope, transaction, typeAction) {
  this.transaction = transaction;
  this.typeAction = typeAction;

  this.$onInit = function () {
    if (this.transaction && this.transaction.note) {
      this.transaction.note = "";
    }
  };

  this.valider = () => {
    if (this.typeAction === "abandonner") {
      this.transaction.etat = 1;
    }

    if (this.typeAction === "valider") {
      this.transaction.type_id = 2;
    }

    this.transaction.note = this.transaction.note === undefined ? "" : this.transaction.note;
    return this.transaction.$update().then(response => {
      $uibModalInstance.close(typeAction);

      if (response.message === undefined) {
        $rootScope.$broadcast("actualiserTransactions");

        if (this.transaction.etat == 1) {
          $rootScope.$broadcast("transactionAbandonnee");
        } else {
          $rootScope.$broadcast("transactionValider");
        }
      } else {
        $rootScope.$broadcast("toasterError", response.message[0]);
      }
    }).catch(function (err) {
      $rootScope.$broadcast("toasterError", err.message);
    });
  };
}]).controller("AddHistoriqueTransactionCtrl", ["AddNoteHistoriqueTransaction", "$rootScope", function (AddNoteHistoriqueTransaction, $rootScope) {
  this.$onInit = () => {
    this.isLoading = false;
  };

  this.save = () => {
    this.isLoading = true;
    return AddNoteHistoriqueTransaction.save({
      transactionId: this.transaction.id,
      note: this.note
    }).$promise.then(response => {
      this.isLoading = false;
      this.note = "";
      $rootScope.$broadcast("refreshTransactionProcedure");
    }).catch(error => {
      this.isLoading = false;
      console.log("erreur AddHistoriqueTransactionCtrl", error);
    });
  };
}]).filter("momentWithTimezone", [function () {
  return function (input, symbol) {
    if (!input) {
      return "-";
    }

    const format = symbol ? symbol : "DD/MM/YYYY H:mm";
    const date = moment.unix(input);
    return date.format(format);
  };
}]);
/**
 * Module definition and dependencies
 */

angular.module("Crm.Transaction", ["Crm.Transaction.Controller", "Crm.transaction.templates"]).component("transaction", {
  controller: "TransactionCtrl",
  templateUrl: "src/transaction/transaction.html",
  bindings: {
    transaction: "<",
    lot: "<",
    vendeur: "<",
    client: "<"
  }
}).component("historiqueTransaction", {
  controller: "HistoriqueTransactionCtrl",
  templateUrl: "src/transaction/historique-transaction.html",
  bindings: {
    transaction: "<"
  }
}).component("btnAbandonnerValiderTransaction", {
  controller: "BtnAbandonnerValiderTransactionCtrl",
  templateUrl: "src/transaction/btn-abandonner-valider-transaction.html",
  bindings: {
    transaction: "=",
    transactions: "=?",
    title: "<",
    typeAction: "<",
    addClass: "<",
    btnDisabled: "<",
    icon: "<"
  }
}).component("addHistoriqueTransaction", {
  controller: "AddHistoriqueTransactionCtrl",
  templateUrl: "src/transaction/add-historique-transaction.html",
  bindings: {
    transaction: "<"
  }
});
angular.module('Crm.transaction.templates', []).run(['$templateCache', function($templateCache) {$templateCache.put('src/transaction/add-historique-transaction.html','<div class="input-group"> <input type="text" class="form-control" ng-model="$ctrl.note" placeholder="Votre message"/> <span class="input-group-btn"><button class="btn btn-primary" type="button" ng-click="$ctrl.save()" ng-disabled="$ctrl.isLoading || $ctrl.note.length === 0" promise-btn> <span class="btn-text">Enregistrer</span></button></span></div>');
$templateCache.put('src/transaction/btn-abandonner-valider-transaction.html','<a title="{{ $ctrl.title }}" class="{{ $ctrl.addClass }}" ng-click="$event.stopPropagation();$ctrl.openModal($ctrl.btnDisabled)" tooltip-placement="top" uib-tooltip="Il faut pr\xE9alablement annuler le contrat avant d\'abandonner la transaction" tooltip-enable="$ctrl.transaction.signature_procedure_status === 10" ng-disabled="$ctrl.btnDisabled\r\n  || $ctrl.transaction.signature_procedure_status === 10 \r\n  || ($ctrl.transaction.signature_procedure_status === 35 && !$ctrl.hasRolesAdmin)\r\n  || ($ctrl.transaction.signature_procedure_status === 40 && !$ctrl.hasRolesAdmin)\r\n  || ($ctrl.transaction.signature_procedure_status === 50 && !$ctrl.hasRolesAdmin)" ng-class="$ctrl.btnDisabled ? \'btn-tertiary\' : \'btn-primary\'"><ng-container ng-if="$ctrl.icon"><i class="{{$ctrl.icon}}"></i></ng-container> {{ $ctrl.title }}</a>');
$templateCache.put('src/transaction/historique-transaction.html','<table class="table table-striped table-bordered"><thead><tr><th>Date</th><th>Message</th></tr></thead><tbody><tr ng-repeat="historique in $ctrl.listeHistorique track by $index" ng-if="!$ctrl.loading"><td>{{ historique.createdAt | momentWithTimezone }}</td><td>{{ historique.defaultMessage }}</td></tr><tr class="text-center" ng-if="!$ctrl.listeHistorique.length === 0 && !$ctrl.loading"><td colspan="2"> Aucun historique.</td></tr><tr ng-if="$ctrl.loading" class="text-center"><td colspan="2"><div class="content_loader"><div class="loader_1">Loading...</div><span class="spacer--xs"></span></div></td></tr></tbody></table>');
$templateCache.put('src/transaction/modal-transaction.html','<div class="modal-header"><h3 ng-switch="$ctrl.typeAction" class="modal-title h4" id="modal-title"> <span ng-switch-when="abandonner"><span ng-switch="$ctrl.transaction.type_label"><span ng-switch-when="R\xE9serv\xE9">Voulez-vous vraiment abandonner cette r\xE9servation ?</span> <span ng-switch-when="Optionn\xE9">Voulez-vous vraiment abandonner cette option ?</span> <span ng-switch-when="Vendu">Voulez-vous vraiment abandonner cette vente ?</span> <span ng-switch-when="Sign\xE9">Voulez-vous vraiment abandonner cette transaction en cours de signature ?</span></span></span> <span ng-switch-when="valider"><span ng-switch="$ctrl.transaction.type_label"><span ng-switch-when="R\xE9serv\xE9">Voulez-vous vraiment valider cette r\xE9servation ?</span> <span ng-switch-when="Optionn\xE9">Voulez-vous vraiment valider cette option ?</span> <span ng-switch-when="Vendu">Voulez-vous vraiment valider cette vente ?</span> <span ng-switch-when="Sign\xE9">Voulez-vous vraiment valider cette transaction en cours de signature ?</span></span></span></h3></div><div class="modal-body" id="modal-body"> Transaction du lot <strong>{{ $ctrl.transaction.lot_nom }}</strong> du programme <strong>{{ $ctrl.transaction.programme_nom }}</strong> par le client <strong>{{ $ctrl.transaction.client_nom + \' \' + $ctrl.transaction.client_prenom }}</strong><textarea ng-model="$ctrl.transaction.note" class="form-control mt-1" rows="5" placeholder="Message"></textarea></div><div class="modal-footer"> <button class="btn btn-danger" type="button" ng-click="$dismiss()"> Annuler</button> <button class="btn btn-primary" type="button" ng-click="$ctrl.valider($ctrl.transaction.id)" promise-btn> <span class="btn-text">Valider</span></button></div>');
$templateCache.put('src/transaction/transaction.html','<div class="spacer spacer--xs"></div><div class="{{ $ctrl.classTransaction }}"><div class="row mb-1"><div class="col-xs-12"> <button class="btn btn-primary" ng-click="$ctrl.back()"> Retour</button></div></div><div class="row"><div class="col-xs-12 col-md-6"><contact contact="$ctrl.client"></contact><espace-client-panel client="$ctrl.client" transaction="$ctrl.transaction" programme="$ctrl.programme" lot="$ctrl.lot"></espace-client-panel><generer-contrat transaction="$ctrl.transaction" ng-if="$ctrl.transaction.type_id !== 1"></generer-contrat></div><div class="col-xs-12 col-md-6"><annexe lot="$ctrl.lot" transaction="$ctrl.transaction" programme="$ctrl.programme"></annexe><div class="row"><div class="col-xs-12 col-lg-5"><vendeur vendeur="$ctrl.vendeur" transaction="$ctrl.transaction"></vendeur></div><div class="col-xs-12 col-lg-7"><lot-transaction lot="$ctrl.lot" transaction="$ctrl.transaction"></lot-transaction></div></div><div class="row"><div class="col-xs-12"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Transaction</h3></div><div class="panel-body"><div class="row"><div class="col-xs-12 col-md-6"><div class="form-group"> <label>Statut du lot</label><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i> <select name="lot_statut" class="form-control" ng-model="$ctrl.transaction.type_id" ng-options="statut.id as statut.label for statut in $ctrl.listStatuts" ng-disabled="!$root.membreConnecter.is_admin || $ctrl.transaction.etat == 1 || $ctrl.is_promoteur || $ctrl.transaction.signature_procedure_status && $ctrl.transaction.signature_procedure_status >= 0 && $ctrl.transaction.signature_procedure_status <= 55"></select></div></div></div></div><div class="row mt-1"><div class="col-xs-12 col-md-6 mb-1"><div class="form-group"> <label>Statut du lot pos\xE9 le :</label><div class="input-group" ng-if="$root.membreConnecter.is_admin"> <input type="text" class="form-control brand-primary" d-uib-datepicker-popup uib-datepicker-popup="dd/MM/yyyy" ng-model="$ctrl.transaction.date_debut.date" ng-model-options="{timezone: \'utc\'}" ng-click="openDatePickerPose = true" is-open="openDatePickerPose" datepicker-options="$ctrl.datePickerOptionsPose" show-button-bar="false" readonly ng-disabled="$ctrl.transaction.etat == 1 || $ctrl.is_promoteur"/><span class="input-group-addon hidden-xs" ng-click="openDatePickerPose"><span class="glyphicon glyphicon-time"></span></span></div> <input type="text" ng-if="!$root.membreConnecter.is_admin" class="form-control" ng-model="$ctrl.transaction.date_debut.date" disabled/></div></div><div class="col-xs-12 col-md-6 mb-1"><div class="form-group"> <label>Valable jusqu\'au :</label><div class="input-group" ng-if="$root.membreConnecter.is_admin"> <input type="text" class="form-control brand-primary" d-uib-datepicker-popup uib-datepicker-popup="dd/MM/yyyy" ng-model="$ctrl.transaction.date_validite.date" ng-click="openDatePickerEnd = true" is-open="openDatePickerEnd" datepicker-options="$ctrl.datePickerOptionsEnd" show-button-bar="false" readonly ng-disabled="$ctrl.transaction.etat == 1 || $ctrl.is_promoteur"/><span class="input-group-addon hidden-xs" ng-click="openDatePickerEnd"><span class="glyphicon glyphicon-time"></span></span></div> <input type="text" ng-if="!$root.membreConnecter.is_admin" class="form-control" ng-model="$ctrl.transaction.date_validite.date" disabled/></div></div><div class="col-xs-12 col-md-6 mb-1"><div class="form-group"> <label>Date signature notaire pr\xE9visionnelle :</label><div class="input-group"> <input type="text" class="form-control brand-primary" uib-datepicker-popup="dd/MM/yyyy" d-uib-datepicker-popup ng-model="$ctrl.transaction.date_signature_notaire_prev.date" ng-click="openPickerSignatureNotairePrev = true" is-open="openPickerSignatureNotairePrev" datepicker-options="$ctrl.datePickerOptionsSignatureNotairePrev" ng-disabled="$ctrl.is_promoteur" show-button-bar="false" readonly/><span class="input-group-addon hidden-xs" ng-click="openDatePickerEnd"><span class="glyphicon glyphicon-time"></span></span></div></div></div><div class="col-xs-12 col-md-6 mb-1"><div class="form-group"> <label>Date signature notaire :</label><div class="input-group"> <input type="text" class="form-control brand-primary" uib-datepicker-popup="dd/MM/yyyy" d-uib-datepicker-popup ng-model="$ctrl.transaction.date_signature_notaire.date" ng-click="openPickerSignatureNotaire = true" is-open="openPickerSignatureNotaire" datepicker-options="$ctrl.datePickerOptionsDateSignatureNotaire" ng-disabled="$ctrl.is_promoteur" show-button-bar="false" readonly/><span class="input-group-addon hidden-xs" ng-click="openDatePickerEnd"><span class="glyphicon glyphicon-time"></span></span></div></div></div></div><div class="row mt-1"><div class="col-xs-12"><div class="form-group"> <label>Notes</label><div class="form-group--select"><textarea ng-model="$ctrl.transaction.note" class="form-control" rows="4" cols="80" ng-disabled="!$root.membreConnecter.is_admin || $ctrl.transaction.etat == 1"></textarea></div></div></div></div><div class="row" admin-only><div class="col-xs-12 text-center"><form class="form-inline"><btn-abandonner-valider-transaction transaction="$ctrl.transaction" title="\'Abandonner\'" type-action="\'abandonner\'" add-class="\'btn btn-tertiary mt-1 mr-1\'"></btn-abandonner-valider-transaction> <button type="submit" class="btn btn-secondary mt-1 mr-1" ng-click="$ctrl.enregistrerTransaction()" promise-btn> <span class="btn-text">Enregistrer la transaction</span></button></form></div></div></div></div></div></div></div></div><div class="tab-container" type="tabs"><ul class="nav nav-tabs"><li ng-repeat="tab in $ctrl.tabsData" class="tab uib-tab nav-item" ui-sref="{{tab.route}}" ui-sref-active="active"> <a class="nav-link">{{tab.heading}}</a></li></ul><div class="tab-content"><div class="tab-pane active"><ui-view></ui-view></div></div></div></div>');
$templateCache.put('src/transaction/tabs/client-documents.html','<list-demandes-documents contact="$ctrl.client" show-col-checkbox="false" ng-if="$ctrl.client.statut_activation"></list-demandes-documents><div class="spacer spacer--xs"></div><liste-documents-contact contact="$ctrl.client" show-panel-heading="false"></liste-documents-contact>');
$templateCache.put('src/transaction/tabs/client-historique.html','<historiques-contact contact="$ctrl.client"></historiques-contact>');
$templateCache.put('src/transaction/tabs/transaction-historique.html','<div class="row"><div class="col-xs-12"><historique-transaction transaction="$ctrl.transaction"></historique-transaction></div></div><div class="row"><div class="col-xs-12"><add-historique-transaction transaction="$ctrl.transaction"></add-historique-transaction></div></div>');}]);